import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import TopBar from "../../../components/TopBar/TopBar";
import { getAllClinicPayment, getRecentTransactionsPayment } from "../../../redux/reducers/clinicSlice";
import { deletePaymentById } from "../../../redux/reducers/paymentSlice";
import VetAndUpcomingAppointments from "../../CommonScreens/VetAndUpcomingAppointments/VetAndUpcomingAppointments";
import Payments from "./Payment";
import PointOfSales from "./PointOfSales";

const ClinicPayments = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Payments");
  const [selectedPayment, setSelecetdPayment] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const defaultUrl = "?filter=all&type=resent";

  const handleEdit = (dta) => {
    setActiveTab("PointOfSales");
    setSelecetdPayment(dta);
    setPaymentId(dta?.paymentId);
  };

  const handleChangeTab = (tab) => {
    setSelecetdPayment(null);
    setPaymentId(null);
    setActiveTab(tab);
  };

  const handleDelete = (pay) => {
    setPaymentId(pay?.paymentId);
    setDelModVsble(true);
  };

  const handleCloseDelMod = () => {
    setPaymentId(null);
    setDelModVsble(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deletePaymentById(paymentId)).then((res) => {
      if (res?.payload) {
        handleCloseDelMod();
        dispatch(getRecentTransactionsPayment(defaultUrl));
        dispatch(getAllClinicPayment(`?filter=all&type=all&page=1&itemSize=10`));
      }
    });
  };

  return (
    <>
      <VetAndUpcomingAppointments
        left={false}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      >
        <TopBar>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="back-white">
                <div className="flex-row">
                  <div className="w15Per">
                    <CustomButton
                      text="Payments"
                      onClick={() => handleChangeTab("Payments")}
                      tabOutlined
                      yellowBtn={activeTab === "Payments"}
                    />
                  </div>
                  <div className="w5Per">
                    <div className="flex-center">
                      <div className="ver-bar-h30" />
                    </div>
                  </div>
                  <div className="w15Per">
                    <CustomButton
                      text="Point of Sale"
                      onClick={() => handleChangeTab("PointOfSales")}
                      tabOutlined
                      yellowBtn={activeTab === "PointOfSales"}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </TopBar>
        {activeTab === "Payments" ? <Payments /> : null}
        {activeTab === "PointOfSales" ? (
          <PointOfSales
            selectedPayment={selectedPayment}
            setSelecetdPayment={setSelecetdPayment}
            paymentId={paymentId}
            setPaymentId={setPaymentId}
          />
        ) : null}
      </VetAndUpcomingAppointments>

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure want to delete the payment?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDelMod} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDelete}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ClinicPayments;
